<div class="position-relative text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">{{data.actionName}} Confirmation!</h4>
    <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onCancel()" title="Close"></i>
  </div>
  <div class="modal-body">
    <p>{{ data.message }}</p>
    <p *ngIf="showWarning && actionName == 'Stop'" style="color: red;"><strong>Critical Warning :</strong> You are trying to stop head node while compute node is still in active state. This will impact the deployment.</p>
  </div>

  <div *ngIf="openConsoleAction == true" style="width: 100%; text-align: center; margin-top: 2%">
    <label for="">Note : To open console you need to have <a href="https://releases.pagure.org/virt-viewer/virt-viewer-x64-11.0-1.0.msi">virt-viewer</a> installed.</label>
  </div>
  <!--This option is enabled by default to only remove the node from database without deleting the actual cloud resource.-->
  <div *ngIf="actionName == 'Delete'" style="margin-top: 15px;">
    <mat-checkbox [(ngModel)]="skipCloudDeployment" [checked]="true" [disabled]="true">Skip Infra deployment deletion</mat-checkbox>
    <p style="font-size: 12px; color: #666; margin-top: 5px;">
      <i class="bi bi-info-circle"></i>
      Check this to only remove the node from database without deleting the actual cloud resource.
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">No</button>
    <button type="button" class="btn btn-primary" (click)="onSubmit()" cdkFocusInitial>
      Yes
    </button>
  </div>
  <ngx-spinner bdColor="rgba(0,0,0,0)"
               size="default"
               zIndex="1"
               color="var(--s-primary-color)"
               type="ball-spin"
               [fullScreen]="false"
               name="nodeAction"></ngx-spinner>
</div>
